import nodes from '~src/controllers/NodesController';
import useObservable from './useObservable';

export default function useNode(id?: string) {
	return useObservable(nodes.get$(id));
}